import React, { useEffect, useState } from "react";
import Layout from "./Layout";
import { useNavigate, useParams } from "react-router-dom";
import axios, { cookies } from "../../axios/axios";

const ColorCorrectionDetailManager = () => {
  const [colorCorrection, setColorCorrection] = useState({});
  const [status, setStatus] = useState(1);
  const [errorMessage, setErrorMessage] = useState("");
  const [fileLocation, setFileLocation] = useState("");
  const [editors, setEditors] = useState([]); // List of editors
  const [selectedEditor, setSelectedEditor] = useState(""); // Selected editor
  const [message, setMessage] = useState("");

  const { id } = useParams();
  const navigate = useNavigate();

  const user = cookies.get("user");
  const userRole = user?.user?.role;
  const userName = user?.user?.fname;

  const getColorCorrectionById = async () => {
    try {
      const response = await axios.get(`/color-correction/${id}`);
      setColorCorrection(response.data);
      setSelectedEditor(response.data.editor || ""); // Set selected editor from fetched data
      setFileLocation(response.data.fileLocation || "");
      setStatus(response.data.status || 1); // Set status from fetched data
    } catch (error) {
      console.log(error);
    }
  };

  const getEditors = async () => {
    try {
      const response = await axios.get("/user/allUsers");
      const editorUsers = response.data.filter(
        (user) => user.role === "editor"
      );
      setEditors(editorUsers);
    } catch (error) {
      console.error("Error fetching editors:", error);
    }
  };

  useEffect(() => {
    getColorCorrectionById();
    getEditors();
  }, []);

  const updateColorCorrection = async () => {
    try {
      await axios.put(`/color-correction/${id}`, {
        status,
        editor: userRole === "editor" ? userName : selectedEditor,
        fileLocation,
        message,
      });
      navigate("/colorcorrection-manager");
    } catch (error) {
      console.log(error);
      setErrorMessage(error.response?.data?.message || "An error occurred");
    }
  };

  return (
    <Layout>
      <div className="container mt-4">
        {errorMessage && (
          <div
            className="alert alert-danger alert-dismissible fade show"
            role="alert"
          >
            {errorMessage}
            <button
              type="button"
              className="btn-close shadow-none"
              data-bs-dismiss="alert"
              aria-label="Close"
            ></button>
          </div>
        )}
        <div className="row">
          <div className="col-md-6">
            <div className="card mb-3">
              <div className="card-header fw-600">Job Details</div>
              <div className="card-body">
                <p>
                  <strong>Event Name:</strong> {colorCorrection.order_name}
                </p>
                <p>
                  <strong>Service Type:</strong>{" "}
                  {colorCorrection.serviceId?.service}
                </p>
                <p>
                  <strong>Album Type:</strong> {colorCorrection.order_name}
                </p>{" "}
              </div>
            </div>{" "}
            <div className="card mb-3">
              <div className="card-header fw-600">Order Detail</div>
              <div className="card-body">
                <p>
                  <strong>Cropping & Retouching :</strong>{" "}
                  {colorCorrection.cropping_straightening}
                </p>
                <p>
                  <strong>Type of Shoot :</strong>{" "}
                  {colorCorrection.type_of_shoot}
                </p>
                <p>
                  <strong>Type of Image :</strong> {colorCorrection.Image_type}
                </p>{" "}
                <p>
                  <strong>Editing Style :</strong>{" "}
                  {colorCorrection.editing_style}
                </p>{" "}
                <p>
                  <strong>White Balance :</strong>{" "}
                  {colorCorrection.white_balance}
                </p>{" "}
                <p>
                  <strong>Noise Reduction :</strong>{" "}
                  {colorCorrection.noise_reduction}
                </p>{" "}
                <p>
                  <strong>Lens Correction :</strong>{" "}
                  {colorCorrection.lens_correction}
                </p>{" "}
                <p>
                  <strong>Black & White :</strong>{" "}
                  {colorCorrection.black_and_white}
                </p>{" "}
                <p>
                  <strong> Black & White Percentage :</strong>{" "}
                  {colorCorrection.black_white_percentage}
                </p>{" "}
                <p>
                  <strong> Need Sample for Review :</strong>{" "}
                  {colorCorrection.sample_for_review === "yes" ? "Yes" : "No"}
                </p>{" "}
                <p>
                  <strong> Output Format :</strong>{" "}
                  {colorCorrection.output_format}
                </p>{" "}
                <p>
                  <strong> Quantity:</strong> {colorCorrection.quantity}
                </p>{" "}
                <p>
                  <strong> Social media:</strong> {colorCorrection.social_media}
                </p>{" "}
                <p>
                  <strong> Link:</strong> {colorCorrection.drive_link}
                </p>{" "}
                <p>
                  <strong>Upload :</strong> {colorCorrection.images}
                </p>{" "}
                <p>
                  <strong>Additional Notes :</strong>{" "}
                  {colorCorrection.additional_notes}
                </p>{" "}
                {colorCorrection.culling && (
                  <>
                    <p>
                      <strong>Culling Quantity :</strong>{" "}
                      {colorCorrection.culling.quantity || "N/A"}
                    </p>
                    <p>
                      <strong>Culling Percentage :</strong>{" "}
                      {colorCorrection.culling.culling_percentage || "N/A"}
                    </p>
                  </>
                )}
              </div>
            </div>
          </div>

          <div className="col-md-6">
            <div className="card mb-3">
              <div className="card-header fw-600">Order Operations</div>
              <div className="card-body">
                <p>
                  <strong>Client ID:</strong> {colorCorrection.userId?.id}
                </p>
                <p>
                  <strong>Order ID:</strong> {colorCorrection.id}
                </p>
                <p>
                  <strong>User Feedback:</strong>{" "}
                  {colorCorrection.sampleFeedback}
                </p>
                <p>
                  <strong>Order Place Date:</strong>{" "}
                  {new Date(colorCorrection.createdAt).toLocaleDateString()}
                </p>

                <label className="form-label">Order Status</label>
                <select
                  className="form-select"
                  value={status}
                  onChange={(e) => setStatus(Number(e.target.value))}
                >
                  <option value={1}>New Order</option>
                  <option value={2}>In Process</option>
                  <option value={3}>On Hold</option>
                  <option value={4}>In QC</option>
                  <option value={5}>Sample Sent</option>
                  <option value={6}>In Revision</option>
                  <option value={7}>Cancelled</option>
                  <option value={8}>Completed</option>
                </select>
                <div className="mt-3">
                  <label className="form-label">Select Editor</label>
                  <select
                    className="form-select"
                    value={selectedEditor}
                    onChange={(e) => setSelectedEditor(e.target.value)}
                  >
                    <option value="">Select an editor</option>
                    {editors.map((ed) => (
                      <option key={ed._id} value={ed.fname}>
                        {ed.fname}
                      </option>
                    ))}
                  </select>
                </div>

                <label className="form-label mt-3">File Location</label>
                <input
                  type="text"
                  className="form-control"
                  value={fileLocation}
                  onChange={(e) => setFileLocation(e.target.value)}
                />

                <>
                  <label className="form-label mt-3">Message</label>
                  <input
                    type="text"
                    className="form-control"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                  />
                </>

                <button
                  onClick={updateColorCorrection}
                  className="btn text-light bg_maincolor mt-3"
                >
                  Update
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ColorCorrectionDetailManager;
